"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionManager = void 0;
var ability_1 = require("@casl/ability");
var debug_1 = require("debug");
var lodash_1 = require("lodash");
var permission_manager_error_1 = require("./permission-manager-error");
var extra_1 = require("@casl/ability/extra");
var debug = (0, debug_1.default)('pl:PermissionManager');
var PermissionManager = /** @class */ (function () {
    function PermissionManager(fetchPermissionsFunction, ttl, dbEngineName, setSubjectNameToDbModelMapFunction, dynamicResolverGetter, missingIncludesHydrater, applicationName) {
        if (ttl === void 0) { ttl = 60000; }
        this.dbEngineName = dbEngineName;
        this.setSubjectNameToDbModelMapFunction = setSubjectNameToDbModelMapFunction;
        this.dynamicResolverGetter = dynamicResolverGetter;
        this.missingIncludesHydrater = missingIncludesHydrater;
        this.applicationName = applicationName;
        this.includes = {};
        this.dynamicResolverValues = {};
        this.needsFieldSecurity = {};
        this.fetchPermissionsFunction = fetchPermissionsFunction;
        this.ttl = ttl;
        this.fetchDate = new Date(0);
        this.appNameKey = this.applicationName ? PermissionManager.applicationNameToPermissionsPrefix(this.applicationName) : undefined;
    }
    PermissionManager.applicationNameToPermissionsPrefix = function (appName) {
        return appName.replace(/[^a-zA-z0-9_]/g, '');
    };
    PermissionManager.getPlacUrl = function (placHostUrl, application, dbEngineName) {
        var applicationQuery = typeof application === 'string' ? application : application.id ? application.id : 'name:' + application.name;
        return "".concat(placHostUrl.replace(/\/+$/g, ''), "/casl-rules/mine/").concat(applicationQuery).concat(dbEngineName ? '/' + dbEngineName : '');
    };
    PermissionManager.getPlacFetchFunction = function (placHostUrl, application, httpGetter, dbEngineName) {
        return function () { return httpGetter(PermissionManager.getPlacUrl(placHostUrl, application, dbEngineName)); };
    };
    /**
     * Checks if field level security is required (requested by rules) for given model and action.
     * @param model
     * @param action
     */
    PermissionManager.prototype.needsFieldSecurityForActionAndModel = function (model, action) {
        var _this = this;
        if (!this.ability) {
            throw new Error('No ability found');
        }
        var cached = this.needsFieldSecurity[model + action];
        if (cached !== undefined) {
            return cached;
        }
        if (!model) {
            throw new Error('Model is required when checking for field security requirement');
        }
        var subjects = this.getSubjectNamesForModel(model);
        if (!subjects || !subjects.length) {
            throw new Error("Cannot find any subjects for model '".concat(model, "'. At least one is required when checking for field security requirement."));
        }
        var r = (0, lodash_1.flatten)(subjects.map(function (s) { return _this.ability.possibleRulesFor(action, _this.getSubjectNameWithApplicationNameKeyPrefixReplaced(s)); })).filter(function (r) { return !!r.fields; });
        this.needsFieldSecurity[model + action] = r && r.length > 0;
        return this.needsFieldSecurity[model + action];
    };
    /**
     * Calculates and returns all fields that current user is permitted to execute {@link action} on.
     *        {@link model} or {@link subjectName} required if {@link subjectOrEntity} is a non subject object (any)
     *   This method uses {@link ensureSubjects} method to make sure that {@link subjectOrEntity} is a subject
     * @param subjectStringOrEntity - either subject string or Subject (has to be a proper CASL subject e.g. object that had subject() method applied) or any object
     * @param action - action against which to check the fields
     * @param allFields - all possible/available fields for given subject
     * @param subjectName - subject name that will be applied on {@link subjectStringOrEntity} if it's any object
     * @param model - model Name that should be used to retrieve subjectNames to apply to {@link subjectStringOrEntity}
     */
    PermissionManager.prototype.getPermittedFields = function (subjectStringOrEntity, action, allFields, subjectName, model) {
        var _this = this;
        if (!this.ability) {
            throw new Error('No ability found');
        }
        return (0, lodash_1.uniq)((0, lodash_1.flatten)(this.ensureSubjects(subjectStringOrEntity, subjectName, model).map(function (s) {
            return (0, extra_1.permittedFieldsOf)(_this.ability, action, s, { fieldsFrom: function (r) { return r.fields || allFields; } });
        })));
    };
    PermissionManager.prototype.getSubjectNamesForModel = function (model) {
        if (!this.dbModelToSubjectName) {
            throw new Error('setSubjectNameToDbModelMapFunction has not been provided or returned undefined. Please provide setSubjectNameToDbModelMapFunction in the configuration.');
        }
        return this.dbModelToSubjectName[model];
    };
    PermissionManager.prototype.getModelForSubjectName = function (subjectName) {
        if (!this.subjectNameToDbModelMap) {
            throw new Error('setSubjectNameToDbModelMapFunction has not been provided or returned undefined. Please provide setSubjectNameToDbModelMapFunction in the configuration.');
        }
        return this.subjectNameToDbModelMap[subjectName];
    };
    PermissionManager.prototype.getSubjectToDbModelMap = function () {
        return __assign({}, this.subjectNameToDbModelMap);
    };
    PermissionManager.prototype.getDbModelToSubjectMap = function () {
        return __assign({}, this.dbModelToSubjectName);
    };
    /**
     * Invalidates the cache for casl rules.
     * This will cause a refresh of rules with the next request to has permissions.
     */
    PermissionManager.prototype.invalidate = function () {
        debug('Invalidating permission manager cache');
        this.fetchDate = new Date(1976, 1, 1);
    };
    /**
     * Invalidates the cache for casl rules and calls refreshDataIfNeeded to
     * refresh all the rules instantly.
     */
    PermissionManager.prototype.forceRefresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        debug('Force refreshing permission manager.');
                        this.invalidate();
                        return [4 /*yield*/, this.refreshDataIfNeeded()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PermissionManager.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var success, _a, _b, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 6]);
                        this.dynamicResolverValues = {};
                        return [4 /*yield*/, this.fetchData(true)];
                    case 1:
                        success = _c.sent();
                        if (!success) return [3 /*break*/, 4];
                        _a = this;
                        return [4 /*yield*/, this.getAbility()];
                    case 2:
                        _a.ability = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.getDbEngineAbility()];
                    case 3:
                        _b.dbEngineAbility = _c.sent();
                        return [2 /*return*/, true];
                    case 4: return [2 /*return*/, Promise.reject(new Error('No profile was fetched'))];
                    case 5:
                        e_1 = _c.sent();
                        debug(e_1);
                        return [2 /*return*/, Promise.reject(new permission_manager_error_1.PermissionManagerError('Error while initializing permission manager. ' + e_1, e_1))];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    PermissionManager.prototype.refreshDataIfNeeded = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isCacheExpired()) return [3 /*break*/, 5];
                        debug("TTL for permission manager rules expired. Fetching new rules.");
                        if (!this.isInitRunning) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.isInitRunning];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        this.isInitRunning = this.init();
                        return [4 /*yield*/, this.isInitRunning];
                    case 3:
                        _a.sent();
                        this.isInitRunning = undefined;
                        return [2 /*return*/, true];
                    case 4:
                        e_2 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_2)];
                    case 5: return [2 /*return*/, false];
                }
            });
        });
    };
    PermissionManager.prototype.hasPermissionToModel = function (subject, action, field, subjectName, model) {
        return __awaiter(this, void 0, void 0, function () {
            var r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.hasPermissionToModelWithHydrationResults(subject, action, field, subjectName, model)];
                    case 1:
                        r = _a.sent();
                        return [2 /*return*/, typeof r === 'boolean' ? r : r.permissionCheckResult];
                }
            });
        });
    };
    /**
     * Makes sure that supplied {@link subjectStringOrEntity} is a Subject in CASL (had subject() method applied and that this.ability.detectSubjectType(subject) resolves to a subjectName)
     *    {@link model} or {@link subjectName} required if {@link subjectOrEntity} is a non subject object (any)
     *
     * @param subjectStringOrEntity - either subject string (this is not the same as model!!!!) or Subject (has to be a proper CASL subject e.g. object that had subject() method applied) or any object
     * @param subjectName - subject name that will be applied on {@link subjectStringOrEntity} if it's any object
     * @param model - model Name that should be used to retrieve subjectNames to apply to {@link subjectStringOrEntity}   *
     */
    PermissionManager.prototype.ensureSubjects = function (subjectStringOrEntity, subjectName, model) {
        var _this = this;
        if (typeof subjectStringOrEntity === 'string') {
            return [this.getSubjectNameWithApplicationNameKeyPrefixReplaced(subjectStringOrEntity)];
        }
        if (!this.ability) {
            throw new Error('No ability found');
        }
        if (!subjectName && !model) {
            var detectedSubject = this.ability.detectSubjectType(subjectStringOrEntity);
            if (detectedSubject && detectedSubject !== 'Object') {
                return [subjectStringOrEntity];
            }
            throw new Error('SubjectName or model has to be specified. If none are present call hasPermission directly');
        }
        var subjects = subjectName ? [subjectName] : this.getSubjectNamesForModel(model);
        return subjects.map(function (s) { return (0, ability_1.subject)(_this.getSubjectNameWithApplicationNameKeyPrefixReplaced(s), (0, lodash_1.assign)({}, subjectStringOrEntity)); });
    };
    PermissionManager.prototype.hasPermissionToModelWithHydrationResults = function (subject, action, field, subjectName, model) {
        return __awaiter(this, void 0, void 0, function () {
            var r, _i, _a, s;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _i = 0, _a = this.ensureSubjects(subject, subjectName, model);
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        s = _a[_i];
                        return [4 /*yield*/, this.hasPermissionWithHydrationResults(s, action, field)];
                    case 2:
                        r = _b.sent();
                        if (typeof r === 'boolean' && r) {
                            return [2 /*return*/, true];
                        }
                        if (typeof r !== 'boolean' && r.permissionCheckResult === true) {
                            return [2 /*return*/, r];
                        }
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, r || false];
                }
            });
        });
    };
    PermissionManager.prototype.hasPermission = function (subject, action, field, ignoreMissingIncludes) {
        return __awaiter(this, void 0, void 0, function () {
            var r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.hasPermissionWithHydrationResults(subject, action, field)];
                    case 1:
                        r = _a.sent();
                        return [2 /*return*/, typeof r === 'boolean' ? r : r.permissionCheckResult];
                }
            });
        });
    };
    PermissionManager.prototype.hasPermissionWithHydrationResults = function (subject, action, field, ignoreMissingIncludes) {
        return __awaiter(this, void 0, void 0, function () {
            var missingIncludes, hydrationResult, currentSubject, initialDetectedType, subjectNameForIncludes, includes, preIncludesResult, hydrationArgs, tempHydrationResult, subjectForCanCheck, detectedType, replacedSubjectName, subjectObj, _1, subjectWithoutType, result, possibleRules;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refreshDataIfNeeded()];
                    case 1:
                        _a.sent();
                        if (!this.ability) {
                            return [2 /*return*/, Promise.reject(new Error('No ability found'))];
                        }
                        currentSubject = subject;
                        if (!(typeof currentSubject !== 'string')) return [3 /*break*/, 4];
                        initialDetectedType = this.ability.detectSubjectType(currentSubject);
                        subjectNameForIncludes = this.getSubjectNameWithApplicationNameKeyPrefixReplaced(initialDetectedType);
                        includes = (this.includes[subjectNameForIncludes] || {})[action];
                        if (!(includes && Object.keys(includes).length > 0 && !ignoreMissingIncludes)) return [3 /*break*/, 3];
                        missingIncludes = this.getMissingRequiredIncludes(currentSubject, includes);
                        if (!(missingIncludes && (0, lodash_1.keys)(missingIncludes).length > 0)) return [3 /*break*/, 3];
                        preIncludesResult = false;
                        try {
                            preIncludesResult = this.ability.can(action, subject, field);
                        }
                        catch (e) {
                            debug("Error occurred during pre-includes check: ".concat(e));
                        }
                        if (preIncludesResult) {
                            return [2 /*return*/, true];
                        }
                        hydrationArgs = {
                            subject: currentSubject,
                            missingIncludes: missingIncludes,
                            includes: includes,
                            permissionManager: this,
                            subjectName: subjectNameForIncludes,
                            modelName: this.getModelForSubjectName(subjectNameForIncludes),
                            action: action,
                            field: field,
                        };
                        return [4 /*yield*/, this.hydrateMissingIncludes(hydrationArgs)];
                    case 2:
                        tempHydrationResult = _a.sent();
                        currentSubject = tempHydrationResult.subject;
                        if (tempHydrationResult.permissionCheckResult !== undefined) {
                            hydrationResult = tempHydrationResult;
                        }
                        else {
                            hydrationResult = { subject: currentSubject };
                        }
                        // If hydrationResult already contains a definitive permission result, return early
                        if (hydrationResult && hydrationResult.permissionCheckResult !== undefined) {
                            return [2 /*return*/, hydrationResult];
                        }
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        currentSubject = this.getSubjectNameWithApplicationNameKeyPrefixReplaced(currentSubject);
                        _a.label = 5;
                    case 5:
                        subjectForCanCheck = currentSubject;
                        if (typeof currentSubject === 'object' && currentSubject !== null) {
                            detectedType = this.ability.detectSubjectType(currentSubject);
                            if (detectedType && detectedType.includes(PermissionManager.applicationNameKeyPrefix)) {
                                if (this.applicationName && this.appNameKey) {
                                    replacedSubjectName = this.getSubjectNameWithApplicationNameKeyPrefixReplaced(detectedType);
                                    subjectObj = typeof currentSubject === 'object' && currentSubject !== null ? currentSubject : {};
                                    _1 = subjectObj.__caslSubjectType__, subjectWithoutType = __rest(subjectObj, ["__caslSubjectType__"]);
                                    subjectForCanCheck = (0, ability_1.subject)(replacedSubjectName, subjectWithoutType);
                                    debug("Applied CaslSubject wrapper with replaced type '".concat(replacedSubjectName, "' for 'can' check."));
                                }
                                else {
                                    debug("Warning: Detected placeholder '".concat(PermissionManager.applicationNameKeyPrefix, "' in subject type '").concat(detectedType, "' but applicationName is not configured in PermissionManager. Proceeding with check using placeholder type."));
                                }
                            }
                        }
                        try {
                            result = this.ability.can(action, subjectForCanCheck, field);
                        }
                        catch (e) {
                            result = false;
                            debug("Error while checking permissions. Probably subject has missing required includes. Please check following log. Error: %o", e);
                        }
                        if (!result) {
                            possibleRules = this.ability.possibleRulesFor(action, this.ability.detectSubjectType(subject));
                            debug("Access Denied.\n        Action: %o.\n        Field: %o.\n        Possible rules no: %o.\n        Conditions: %o.\n        Subject used for check: %o.\n        Original Subject (pre-check): %o.\n        Missing includes: %o.\n        Full rules: %o.", action, field, possibleRules.length, possibleRules.map(function (e) { return e.conditions; }), subjectForCanCheck, // Log the subject actually used in .can()
                            currentSubject, // Log the subject state before potential re-wrapping
                            missingIncludes, possibleRules);
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    PermissionManager.prototype.getModelWhereStatement = function (model, action, options) {
        // TODO: Change action to be typed to PermissionActions. Is this function used for non-standard action checks?
        // return  accessibleBy(ability)[this.model];
        throw new Error('Please derive from PermissionManager and override getModelWhereStatement to get a where statement based on ability.');
    };
    PermissionManager.prototype.getDynamicResolverValue = function (resolverName, parameters, attributeValue) {
        return __awaiter(this, void 0, void 0, function () {
            var conditionsOrValue, errorMessageResolverNotFound, errorMessageResolverCannotGetValue, key, fetchPromise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        conditionsOrValue = attributeValue || resolverName + ':' + parameters;
                        if (!this.dynamicResolverGetter) {
                            throw new Error("Dynamic resolver getter not provided in permissionsManager. But it is needed to resolver expression ".concat(conditionsOrValue, "."));
                        }
                        errorMessageResolverNotFound = "Dynamic Resolver of type ".concat(resolverName, " not found. Please add it your implementation of dynamicResolverGetter passed to permission-manager");
                        errorMessageResolverCannotGetValue = "Dynamic Resolver of type ".concat(resolverName, " errored while getting value for ").concat(conditionsOrValue, " and parameters ").concat(parameters);
                        key = "".concat(resolverName, "-").concat(conditionsOrValue, "-").concat(parameters);
                        if (!this.dynamicResolverValues[key + '-promise']) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dynamicResolverValues[key + '-promise']];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        if (this.dynamicResolverValues[key]) {
                            return [2 /*return*/, this.dynamicResolverValues[key]];
                        }
                        fetchPromise = new Promise(function (resolve, reject) {
                            _this.dynamicResolverGetter.get(resolverName)
                                .then(function (r) {
                                if (r) {
                                    r.resolve(conditionsOrValue, parameters)
                                        .then(function (v) {
                                        _this.dynamicResolverValues[key] = v;
                                        delete _this.dynamicResolverValues[key + '-promise'];
                                        resolve(_this.dynamicResolverValues[key]);
                                    })
                                        .catch(function (e) {
                                        delete _this.dynamicResolverValues[key];
                                        delete _this.dynamicResolverValues[key + '-promise'];
                                        reject("".concat(errorMessageResolverCannotGetValue, " .Internal Error: ").concat(e));
                                    });
                                    return;
                                }
                                reject("".concat(errorMessageResolverNotFound, ". Internal Error: Returned resolver is undefined."));
                            })
                                .catch(function (e) {
                                delete _this.dynamicResolverValues[key];
                                delete _this.dynamicResolverValues[key + '-promise'];
                                reject("".concat(errorMessageResolverNotFound, ". Internal Error: ").concat(e));
                            });
                        });
                        this.dynamicResolverValues[key + '-promise'] = fetchPromise;
                        return [4 /*yield*/, fetchPromise];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PermissionManager.prototype.getSubjectNameWithApplicationNameKeyPrefixReplaced = function (subject) {
        if (this.applicationName && this.appNameKey) {
            return subject.replace(PermissionManager.applicationNameKeyPrefix, this.appNameKey);
        }
        else {
            if (subject.indexOf(PermissionManager.applicationNameKeyPrefix) > 0) {
                throw new Error("Detected appNameKey prefix '".concat(PermissionManager.applicationNameKeyPrefix, "'in subjectNameToDbModelMap but no applicationName provided in PermissionManager constructor. Please either provide applicationName or make sure that supplied subjectNameToDbModelMap returns full permission subjects."));
            }
        }
        return subject;
    };
    PermissionManager.prototype.getCaslDataOnly = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.rules) {
                            throw new Error('No rules defined. Please call init and make sure it worked.');
                        }
                        if (this.caslOnlyRules) {
                            return [2 /*return*/, this.caslOnlyRules];
                        }
                        _a = this;
                        return [4 /*yield*/, Promise.all(this.rules.map(function (e) { return __awaiter(_this, void 0, void 0, function () {
                                var r, _a;
                                var _this = this;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            r = this.dbEngineName ? (0, lodash_1.pickBy)(e, function (v, k) { return !k.endsWith(_this.dbEngineName + '_conditions'); }) : e;
                                            _a = r;
                                            return [4 /*yield*/, this.evaluateDynamicResolvers(r.conditions)];
                                        case 1:
                                            _a.conditions = _b.sent();
                                            return [2 /*return*/, r];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.caslOnlyRules = _b.sent();
                        return [2 /*return*/, this.caslOnlyRules];
                }
            });
        });
    };
    PermissionManager.prototype.getDbEngineDataOnly = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.rules) {
                            throw new Error('No rules defined. Please call init and make sure it worked.');
                        }
                        if (this.dbEngineRules) {
                            return [2 /*return*/, this.dbEngineRules];
                        }
                        if (!this.dbEngineName) {
                            return [2 /*return*/, undefined];
                        }
                        _a = this;
                        return [4 /*yield*/, Promise.all(data.map(function (e) { return __awaiter(_this, void 0, void 0, function () {
                                var conditions, _a, _b;
                                var _c;
                                return __generator(this, function (_d) {
                                    switch (_d.label) {
                                        case 0:
                                            conditions = (0, lodash_1.pickBy)((0, lodash_1.assign)({}, e.conditions, e[this.dbEngineName + '_conditions']), function (v) { return v !== '$$REMOVE$$'; });
                                            _a = lodash_1.assign;
                                            _b = [{}, e];
                                            _c = {};
                                            return [4 /*yield*/, this.evaluateDynamicResolvers((0, lodash_1.keys)(conditions).length === 0 ? undefined : conditions)];
                                        case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([(_c.conditions = _d.sent(),
                                                    _c)]))];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.dbEngineRules = _b.sent();
                        return [2 /*return*/, this.dbEngineRules];
                }
            });
        });
    };
    PermissionManager.prototype.getAbility = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCaslDataOnly()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new ability_1.Ability(this.caslOnlyRules)];
                }
            });
        });
    };
    PermissionManager.prototype.getDbEngineAbility = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.rules) {
                            throw new Error('No rules defined. Please call init and make sure it worked.');
                        }
                        if (!this.dbEngineName) {
                            return [2 /*return*/, undefined];
                        }
                        return [4 /*yield*/, this.getDbEngineDataOnly(this.rules)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new ability_1.Ability(this.dbEngineRules)];
                }
            });
        });
    };
    PermissionManager.prototype.fetchData = function (force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, e_3, _c, _d, e_4;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!(!this.rules || force)) return [3 /*break*/, 4];
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        _a = this;
                        _b = lodash_1.orderBy;
                        return [4 /*yield*/, this.fetchPermissionsFunction()];
                    case 2:
                        _a.rules = _b.apply(void 0, [(_e.sent()) || [], function (e) { return e === null || e === void 0 ? void 0 : e.inverted; }]);
                        this.caslOnlyRules = undefined;
                        this.dbEngineRules = undefined;
                        this.fetchDate = new Date();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _e.sent();
                        if (e_3.status === 403 || e_3.status === 401) {
                            return [2 /*return*/, Promise.reject(new permission_manager_error_1.PermissionManagerError("Failed to fetch rules. Forbidden error received", e_3))];
                        }
                        return [2 /*return*/, Promise.reject(new permission_manager_error_1.PermissionManagerError("Failed to fetch rules.", e_3))];
                    case 4:
                        if (!(!this.subjectNameToDbModelMap && this.setSubjectNameToDbModelMapFunction)) return [3 /*break*/, 8];
                        _e.label = 5;
                    case 5:
                        _e.trys.push([5, 7, , 8]);
                        _c = this;
                        _d = lodash_1.mapKeys;
                        return [4 /*yield*/, this.setSubjectNameToDbModelMapFunction()];
                    case 6:
                        _c.subjectNameToDbModelMap = _d.apply(void 0, [_e.sent(), function (v, k) {
                                return _this.getSubjectNameWithApplicationNameKeyPrefixReplaced(k);
                            }]);
                        this.dbModelToSubjectName = (0, lodash_1.invertBy)(this.subjectNameToDbModelMap);
                        return [3 /*break*/, 8];
                    case 7:
                        e_4 = _e.sent();
                        return [2 /*return*/, Promise.reject(new permission_manager_error_1.PermissionManagerError('Failed to fetch subjectNameToDbModelMap', e_4))];
                    case 8: return [4 /*yield*/, this.buildRequiredIncludes()];
                    case 9:
                        _e.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    PermissionManager.prototype.hydrateMissingIncludes = function (hydrateArgs) {
        return __awaiter(this, void 0, void 0, function () {
            var e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!this.missingIncludesHydrater) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.missingIncludesHydrater.hydrate(hydrateArgs)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        e_5 = _a.sent();
                        debug('Error while hydrating missing includes. %o', e_5);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, { subject: hydrateArgs.subject }];
                }
            });
        });
    };
    PermissionManager.prototype.isCacheExpired = function () {
        return this.fetchDate.getTime() + this.ttl < new Date().getTime();
    };
    PermissionManager.prototype.buildRequiredIncludes = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.rules) {
                    throw new Error('No rules defined. Please call init and make sure it worked.');
                }
                this.includes = (0, lodash_1.mapValues)((0, lodash_1.groupBy)(this.rules, function (e) { return e.subject; }), function (e) {
                    var includesForEachAction = (0, lodash_1.flatten)(e
                        .map(function (r) { return ({ actions: r.action, includes: r.includes }); })
                        // filter empty includes
                        .filter(function (f) { return !!f.includes; })
                        // get {action:**Action**, includes:{...}}[] for each action in rule.
                        .map(function (a) {
                        return (Array.isArray(a.actions) ? a.actions : [a.actions]).map(function (ac) { return ({
                            action: ac,
                            includes: a.includes,
                        }); });
                    }));
                    return (0, lodash_1.mapValues)((0, lodash_1.groupBy)(includesForEachAction, 'action'), function (i) {
                        return (0, lodash_1.reduce)(i, function (rev, curr, index, list) { return (0, lodash_1.merge)(rev, curr.includes); }, {});
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    PermissionManager.prototype.evaluateDynamicResolvers = function (conditionsOrValue) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, conditionsKey, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!conditionsOrValue) {
                            return [2 /*return*/, conditionsOrValue];
                        }
                        if (!(typeof conditionsOrValue === 'object')) return [3 /*break*/, 4];
                        _i = 0, _a = Object.keys(conditionsOrValue);
                        _d.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        conditionsKey = _a[_i];
                        _b = conditionsOrValue;
                        _c = conditionsKey;
                        return [4 /*yield*/, this.evaluateDynamicResolvers(conditionsOrValue[conditionsKey])];
                    case 2:
                        _b[_c] = _d.sent();
                        _d.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        if (!(typeof conditionsOrValue === 'string')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.evaluateDynamicResolver(conditionsOrValue)];
                    case 5: return [2 /*return*/, _d.sent()];
                    case 6: return [2 /*return*/, conditionsOrValue];
                }
            });
        });
    };
    PermissionManager.prototype.evaluateDynamicResolver = function (conditionsOrValue) {
        return __awaiter(this, void 0, void 0, function () {
            var matched, resolvedValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        matched = /#{(.*?)(:(.*))?}/.exec(conditionsOrValue);
                        if (!matched) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getDynamicResolverValue(matched[1], matched[3])];
                    case 1:
                        resolvedValue = _a.sent();
                        return [2 /*return*/, resolvedValue];
                    case 2: return [2 /*return*/, conditionsOrValue];
                }
            });
        });
    };
    PermissionManager.prototype.getMissingRequiredIncludes = function (subject, includes) {
        if (!subject || !includes || (0, lodash_1.isEmpty)(includes)) {
            return undefined;
        }
        var r = {};
        for (var _i = 0, _a = (0, lodash_1.keys)(includes); _i < _a.length; _i++) {
            var key = _a[_i];
            var includesElement = includes[key];
            if (includesElement === undefined) {
                continue;
            }
            var subjectElement = subject[key];
            if (subjectElement === undefined) {
                r[key] = { reason: 'Missing', subIncludes: includesElement };
                continue;
            }
            if (typeof includesElement === 'object') {
                if (Array.isArray(subjectElement)) {
                    if (subjectElement.length > 0) {
                        r[key] = this.getMissingRequiredIncludes(subjectElement[0], includesElement);
                    }
                    if (r[key] === undefined) {
                        delete r[key];
                    }
                    continue;
                }
                if (typeof subjectElement === 'object') {
                    r[key] = this.getMissingRequiredIncludes(subjectElement, includesElement);
                    if (r[key] === undefined) {
                        delete r[key];
                    }
                    continue;
                }
                r[key] = { reason: 'typeMismatch', subIncludes: includesElement };
            }
        }
        return (0, lodash_1.keys)(r).length > 0 ? r : undefined;
    };
    PermissionManager.applicationNameKeyPrefix = '[appNameKey]';
    return PermissionManager;
}());
exports.PermissionManager = PermissionManager;
